export type ForgeChainOption = Readonly<{
  id: number;
  label: string;
}>;

const FORGE_CHAIN_LABELS = new Map<number, string>([
  [24, 'Village'],
  [26, 'Waitrose'],
  [30, 'Morrisons'],
  [33, 'Asda'],
  [41, 'Food Parade'],
  [44, 'Collins Family Markets'],
  [46, 'Lidl GB'],
  [50, 'Lidl FR'],
]);

const PRODUCT_RECOGNITION_CHAIN_LABELS = new Map<number, string>([[44, 'Collins']]);

const DEFAULT_FORGE_CHAIN_ORDER = [24, 26, 30, 33, 41, 44, 46, 50] as const;
const ASDA_FIRST_FORGE_CHAIN_ORDER = [24, 26, 33, 30, 41, 44, 46, 50] as const;

export const DEFAULT_FORGE_CHAIN_ID = 46;
export const SYSTEM_HEALTH_DEFAULT_FORGE_CHAIN_ID = 24;
export const LABELER_FORGE_CHAIN_ID = 46;

function buildForgeChainOptions(
  chainIds: readonly number[],
  labelOverrides: ReadonlyMap<number, string> = new Map<number, string>()
): readonly ForgeChainOption[] {
  return chainIds.map((id) => ({
    id,
    label: labelOverrides.get(id) ?? FORGE_CHAIN_LABELS.get(id) ?? `Chain ${id}`,
  }));
}

export function getForgeChainLabel(chainId: number): string {
  return FORGE_CHAIN_LABELS.get(chainId) ?? `Chain ${chainId}`;
}

export const FORGE_CHAIN_OPTIONS = buildForgeChainOptions(DEFAULT_FORGE_CHAIN_ORDER);
export const FORGE_CHAIN_OPTIONS_ASDA_FIRST = buildForgeChainOptions(ASDA_FIRST_FORGE_CHAIN_ORDER);
export const FORGE_PRODUCT_RECOGNITION_CHAIN_OPTIONS = buildForgeChainOptions(
  DEFAULT_FORGE_CHAIN_ORDER,
  PRODUCT_RECOGNITION_CHAIN_LABELS
);
